import {combineReducers} from 'redux'
import { authReducers } from '../actions/auth'
import { boundaryReducer } from '../actions/boundary'



export const rootReducer = combineReducers({
  authReducer: authReducers,
  boundaries:boundaryReducer
})